<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="hourlysnap">
          <div class="content-panel1" v-show="IshourErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Hour of Week Heatmap</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Hour of Week Heatmap" compId="hourlysnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IshourErr" :class="{ 'contblinking': iskeyHM }">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IshourErr">
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.hourly_heatmap }} You can click on individual boxes/hours/days to
                get
                more insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadhour">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoadhour"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Hour of Week Heatmap</h2>
            <div class="panel-body text-center panelbody-hourht" id="renderhourly" :class="{ 'BlurClass': !isLoadhour }">
              <div class="row">
                <div :class="toggleGraph ? 'col-12 col-lg-9' : 'col-lg-12'">
                  <div id="hourly_dataviz" v-show="Ishourlyshow" class="hourlychr"></div>
                </div>
                <div class="col-12 col-lg-3" :style="toggleGraph ? 'opacity: 1' : 'opacity: 0'">
                  <div id="hourly1_dataviz" v-show="Ishourlyshow" class="hourlychr"></div>
                </div>
              </div>
              <div v-if="Ishourdata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="hourlyInsight" :isInsErr="IshhInsErr" :isErr="IshourErr"
              compTitle="Hour of Week Heatmap" compId="hourlysnap"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var hourlysets, myChartH, myChartH1
function reportWindowSizeHT() {
  if (myChartH != undefined) {
    myChartH.resize()
    myChartH1.resize()
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import widgetsSlider from '../smallcomp/widgets-slider.vue';
export default {
  name: 'HourlyTrend',
  mixins: [screenShotMix],
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      isLoadhour: false,
      IshourErr: false,
      Ishourlyshow: false,
      Ishourdata: false,
      istktshown: true,
      IshhInsErr: false,
      iskeyHM: false,
      hourlyInsight: [],
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isBar: false,
      hourlywholedata: null,
      toggleGraph: true,
    }
  },
  methods: {
    toggleGraphFun() {
      this.toggleGraph = !this.toggleGraph
      setTimeout(() => {
        reportWindowSizeHT()
      }, 0);
    },
    swapCharts() {
      this.isBar = !this.isBar;
      if (this.isBar) {
        this.draw2Grid()
      } else {
        this.drawHourly();
      }
    },
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getHourlyInsight()
    },
    addToSlider() {
      let insArr = this.hourlyInsight;
      let name = "Hour of Week Heatmap - " + this.getPins.viewName;
      let screenShort = {
        id: 'hourlysnap',
        name: 'hourlysnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    downloadDom() {
      let imgname = "Hourly_Heatmap.png"
      let widgetID = "hourlysnap"
      var geticondiv = document.querySelectorAll('#hourlysnap .insideL, #hourlysnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'Hour of Week Heatmap_Insights.txt'
      let insArr
      insArr = this.hourlyInsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    drawHourly() {
      hourlysets = this.hourlywholedata.weekdata
      var emit = this.$emit
      var days
      var times
      const self = this;
      if (this.hourlywholedata.we_config == "wefs") {
        days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      } else {
        days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      }
      times = ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12pm",
        "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"
      ];
      let chartDom = document.getElementById('hourly_dataviz');
      if(chartDom == null) return;
      if (chartDom != null && chartDom != undefined) {
        chartDom.style.height = "370px"
        myChartH = echarts.init(chartDom);
        let option;
        let data = [];
        let maxValue = 0;
        for (let index = 0; index < hourlysets.length; index++) {
          const element = hourlysets[index];
          data.push([element.day - 1, element.hour - 1, element.value, element.perc])
          if (element.value > maxValue) {
            maxValue = element.value;
          }
        }
        var isScatterEffectH = true;
        option = {
          tooltip: {
            position: 'top',
            confine: true,
            formatter: (params) => {
              return params.marker + " #Tickets for " + days[params.value[1]] + " at " +
                times[params.value[
                0]] + " is " + params.value[2].toLocaleString() + "(" + params.value[
                3] + "%)";
            },
          },
          grid: {
            show: false,
            top: 48,
            bottom: 40,
            left: 120,
            right: 20
          },
          toolbox: {
            show: true,
            top: 0,
            right: 20,
            feature: {
              myTool1: {
                itemSize: 20,
                iconStyle: {
                  borderColor: '#777'
                },
                show: true,
                title: 'Toggle Animation',
                icon: 'path://M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z',
                onclick: function () {
                  isScatterEffectH = !isScatterEffectH
                  myChartH.setOption({
                    series: [{
                      name: '# Tickets',
                      type: isScatterEffectH ? 'effectScatter' :
                        'heatmap',
                      symbolSize: function (val) {
                        let sizeVal = val[2] / maxValue * 15
                        return sizeVal < 5 ? 5 : sizeVal;
                      },
                      symbol: 'roundRect',
                      data: data.map(function (item) {
                        return [item[1], item[0], item[2],
                        item[3] ||
                        '-'
                        ];
                      }),
                      label: {
                        show: isScatterEffectH ? false : true
                      },
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }]
                  })
                  self.toggleGraphFun()
                }
              },
            },
          },
          xAxis: {
            type: 'category',
            triggerEvent: true,
            data: times,
            axisLabel: {
              color: "#777"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#777aaa77'
              }
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: true, // Hide full Line
            },
          },
          yAxis: {
            type: 'category',
            triggerEvent: true,
            data: days,
            axisLabel: {
              color: "#777"
            },
            splitLine: {
              show: true,
              lineStyle: {
                // Dark and light colors will be used in turns
                color: '#777aaa77'
              }
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: false, // Hide full Line
            },
          },
          visualMap: {
            min: 0,
            top: 0,
            max: maxValue,
            dimension: 2,
            inRange: {
              color: this.$store.state.chartColor,
            },
            text: ['High', 'Low'],
            calculable: true,
            orient: 'vertical',
            left: 'left',
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          series: [{
            name: '# Tickets',
            // background: 'transparent',
            type: 'effectScatter',
            symbolSize: function (val) {
              let sizeVal = val[2] / maxValue * 15
              return sizeVal < 5 ? 5 : sizeVal;
            },
            symbol: 'roundRect',
            data: data.map(function (item) {
              return [item[1], item[0], item[2], item[3] || '-'];
            }),
            label: {
              show: true,
              overflow: 'truncate',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        };
        option && myChartH.setOption(option, {
          notMerge: true
        });
        myChartH.on('click', function (params) {
          let clickitem;
          if (params.componentType == "yAxis") {
            clickitem = {
              "currpass": params.value + "~null",
              "filterop": "Day~hour"
            }
          } else if (params.componentType == "xAxis") {
            clickitem = {
              "currpass": "null~" + params.value,
              "filterop": "Day~hour"
            }
          } else if (params.componentType == "series") {
            clickitem = {
              "currpass": (parseInt(params.data[1]) + 1) + "~" + (parseInt(params.data[
                0] +
                1)),
              "filterop": "Day~hour"
            }
          }
          emit("getKDrill", clickitem)
        });
        this.draw2Grid()
      }
    },
    draw2Grid() {
      let dataH = this.hourlywholedata.weekdata;
      var emit = this.$emit;
      var days;
      var times;
      var maxValue = 200;
      if (this.hourlywholedata.we_config == "wefs") {
        days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      } else {
        days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      }
      times = ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12pm",
        "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"
      ];
      let res = Array.from(dataH.reduce((m, {
        day,
        value
      }) => m.set(day, (m.get(day) || 0) + value), new Map), ([day, value]) => (value));
      let res1 = Array.from(dataH.reduce((m, {
        hour,
        value
      }) => m.set(hour, (m.get(hour) || 0) + value), new Map), ([hour, value]) => (value));
      maxValue = Math.max(...res)
      let chartDom1 = document.getElementById('hourly1_dataviz');
      if(chartDom1 == null) return;
      if (chartDom1 != null && chartDom1 != undefined) {
        chartDom1.style.height = "370px"
        myChartH1 = echarts.init(chartDom1);
        let option = {
          color: ['#AA0000'],
          tooltip: {
            position: 'left',
            confine: true,
            formatter: (params) => {
              let clickitem;
              if (["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].includes(params.name)) {
                clickitem = "on"
              } else {
                clickitem = "at"
              }
              return params.marker + " #Tickets " + clickitem + " " + params.name + " is " +
                params.value.toLocaleString() //[2] + "(" + params.value[3] + "%)";
            },
          },
          toolbox: {
            show: false,
          },
          visualMap: {
            show: false,
            min: 0,
            top: 0,
            left: 0,
            max: maxValue,
            inRange: {
              color: this.$store.state.chartColor,
            },
            text: ['High', 'Low'],
            calculable: true,
            orient: 'vertical',
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          legend: [{
            top: 40,
            right: 0,
            orient: 'vertical',
            type: 'scroll',
            textStyle: {
              fontSize: 10,
              color: "#777"
            },
          }],
          grid: [{
            left: 40,
            right: 75,
            top: '5%',
            height: '40%'
          },
          {
            left: 40,
            right: 75,
            top: '55%',
            height: '40%'
          },
          ],
          xAxis: [{
            gridIndex: 0,
            type: 'category',
            data: days,
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
          },
          {
            gridIndex: 1,
            type: 'category',
            data: times,
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
          }
          ],
          yAxis: [{
            gridIndex: 0,
            type: 'value',
            scale: true,
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          },
          {
            gridIndex: 1,
            type: 'value',
            scale: true,
            axisLabel: {
              color: "#777",
              fontSize: 10
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          },
          ],
          series: [{
            // name: element.label,
            dataGroupId: 'S1',
            type: 'bar',
            xAxisIndex: 0,
            yAxisIndex: 0,
            markLine: {
              label: {
                // color: this.$store.state.TClrs=='darkTheme' ? "#ccc":"#000"
                color: '#cc5500',
              },
              data: [{
                type: 'average',
                name: 'Avg'
              }]
            },
            data: res
          }, {
            // name: element.label,
            dataGroupId: 'S1',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            markLine: {
              label: {
                // color: this.$store.state.TClrs=='darkTheme' ? "#ccc":"#000"
                color: '#cc5500',
              },
              data: [{
                type: 'average',
                name: 'Avg'
              }]
            },
            data: res1
          }]
        };
        option && myChartH1.setOption(option, {
          notMerge: true
        });
        myChartH1.on('click', function (params) {
          let clickitem;
          if (["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].includes(params.name)) {
            clickitem = {
              "currpass": params.name + "~null",
              "filterop": "Day~hour"
            }
          } else {
            clickitem = {
              "currpass": "null~" + params.name,
              "filterop": "Day~hour"
            }
          }
          emit("getKDrill", clickitem)
        });
      }
    },
    getHourlyInsight() {
      this.isLoadhour = false
      this.IshourErr = false
      this.Ishourlyshow = false
      this.Ishourdata = false
      this.istktshown = true
      this.IshhInsErr = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/get_hrheat_map?asg_id=' + this.asgId, {
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          this.insightloads = false
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              this.hourlywholedata = response.data
              this.hourlyInsight = this.hourlywholedata.insights
              for (var i = 0; i < this.hourlyInsight.length; i++) {
                this.hourlyInsight[i] = this.hourlyInsight[i].replace(/\|/g, '')
                  .replace(/~/g,
                    '')
              }
              this.Ishourlyshow = true
              if (this.hourlyInsight.length == 0) {
                this.IshhInsErr = true
              }
              setTimeout(() => {
                this.drawHourly()
              }, 10)
            } else if (response.data == "Nodata") {
              this.Ishourdata = true
            } else {
              this.IshourErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Hourly Heatmap. Try after sometime!'
              })
            }
            this.isLoadhour = true
          }
        }).catch((response) => {
          this.IshourErr = true
          this.isLoadhour = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Hourly Heatmap. Try after sometime!'
            })
            // console.log("Exception occured in Hourly Heatmap:" + response)
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getHourlyInsight()
    window.addEventListener("resize", reportWindowSizeHT);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeHT);
  },
  computed: {},
  watch: {
    '$store.state.chartColor': function () {
      if (myChartH != undefined) {
        this.drawHourly()
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panelbody-hourht {
  height: 390px;
}

.hourlychr {
  cursor: pointer;
}

text.dayLabel.axis-workweek,
text.timeLabel {
  fill: rgb(237, 125, 49);
}

.hour.bordered {
  stroke: rgba(222, 0, 0);
  stroke-width: 1px;
}

.hour.bordered1 {
  stroke: rgba(222, 0, 0, 0.75);
  stroke-width: 1px;
  stroke-dasharray: 3;
}

.hour.borderedGreen {
  stroke: rgb(11 104 2 / 90%);
  stroke-width: 2px;
}

.hour.borderedGreen1 {
  stroke: rgb(11 104 2 / 25%);
  stroke-width: 2px;
}

.hour.borderedRed {
  stroke: rgb(191 68 76 / 90%);
  stroke-width: 2px;
}

.hour.borderedRed1 {
  stroke: rgb(191 68 76 / 25%);
  stroke-width: 2px;
}

.content-panel1 {
  height: auto;
  min-height: 675px;
}</style>